import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAccount } from './AccountContext';
import WelcomeSection from './components/WelcomeSection';
import SelectDesignSection from './components/SelectDesignSection';
import { mockRootProps } from './selectDesignMockData';

import logger from '../../../utils/logger';
const PageContainer = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',
  minHeight: '100vh',
  padding: '16px',
  [theme.breakpoints.up('sm')]: {
    padding: '24px 32px'
  },
  [theme.breakpoints.up('md')]: {
    padding: '40px 48px'
  }
}));

const SelectDesignPage = () => {
  const navigate = useNavigate();
  const { accountInfo, loadAccountInfo } = useAccount();
  
  // Ensure account info is loaded from localStorage/context on mount
  useEffect(() => {
    loadAccountInfo();
  }, [loadAccountInfo]);
  
  // Use account info from context, fallback to mock data
  const displayAccountInfo = accountInfo?.businessName ? accountInfo : mockRootProps.accountInfo;
  
  const handleDesignSelect = (design) => {
    logger.log('Selected design:', design);
    try {
      if (design && design.id != null) {
        localStorage.setItem('visibeen.selectedFooterId', String(design.id));
      }
    } catch (e) {
      logger.debug('[SelectDesignPage] unable to persist selected footer id', e);
    }
    navigate('/get-edms/select-edm');
  };

  return (
    <PageContainer>
      <WelcomeSection />
      <SelectDesignSection 
        designs={mockRootProps.designs}
        onDesignSelect={handleDesignSelect}
        accountInfo={displayAccountInfo}
      />
    </PageContainer>
  );
};

export default SelectDesignPage;